package com.ives.utils;

import haxe.Json;
import haxe.Http;

class ContextStatus{
	public function new():Void{}
	public var loaded:Int;
	public var status:String;
	public var total:Int;
}

class DicomContextData{
	public function new():Void{}
	public var max:Array<Float>;
	public var min:Array<Float>;
}

class Histogram{
	public function new():Void{}
	public var maxCount:Int;
	public var maxValue:Float;
	public var minCount:Int;
	public var minValue:Float;
	public var values:Array<Int>;
}

class DicomImageData{
	public function new():Void{}

	// source info
	public var id:String;
	public var sourceName:String;
	public var childIds:Array<String>;

	// study info
	public var studyDate:Float;
	public var modality:String;

	// patient info
	public var institutionName:String;
	public var patientAge:String;
	public var patientName:String;
	public var patientSex:String;

	// meta data
	public var numberOfFrames:Int;
	public var recommendedDisplayFrameRate:Int;
	public var photometricInterpretation:String;
	public var pixelSpacing:Array<Float>; // has to stay as default pixel spacing
	public var windowCenter:Float; // default values
	public var windowWidth:Float; // default values
}

class ECGData{
	public function new():Void{}
	public var label:String;
	public var lines:Array<ECGLine>;
	public var originality:String;
	public var samplingFrequency:Int;
}

class ColorLUT{
	public function new():Void{}
	public var name:String;
	public var center:Float;
	public var width:Float;
}

class ECGLine{
	public function new():Void{}
	public var max:Float;
	public var min:Float;
	public var name:String;
	public var unit:String;
	public var values:Array<Float>;
}

@:generic
class RemotingGenericRequest<T> extends Http {
	private var object:T;
	private var callBack:T->Void;

	public function new(path:String, callBack:T->Void, ?object:T):Void{
		super('${Remoting.serverUrl}${path}');

		this.object = object;
		this.callBack = callBack;
		this.onData = responseHandler;
		this.onError = errorHandler;

		setHeader(Remoting.CONTENT_TYPE_HEADER, Remoting.JSON);
		request();
	}

	private function responseHandler(data:String):Void{
		if(data == null || data.length == 0)
			return callBack(null);

		if(object == null){
			if(data.substr(0, 5) == "<?xml")
				return callBack(cast data);
			else
				return callBack(Json.parse(data));
		}

		var dynamicObject:Dynamic = Json.parse(data);

		for(field in Reflect.fields(dynamicObject))
			Reflect.setProperty(object, field, Reflect.getProperty(dynamicObject, field));

		callBack(object);
	}

	private function errorHandler(error:String):Void{
		trace('error: ${error}');
	}
}

class Remoting{
	public static inline var CONTENT_TYPE_HEADER = 'Content-Type';
	public static inline var JSON = 'application/json';

	public static var serverUrl:String;

	public static function getXML(sourceName:String, id:String, callBack:String->Void):Void{
		new RemotingGenericRequest<String>('dicom/${sourceName}/xml/${id}', callBack);
	}

	public static function getSources(callBack:Array<String>->Void):Void{
		new RemotingGenericRequest<Array<String>>('dicom/sources', callBack);
	}

	public static function getContextStatus(sourceName:String, id:String, callBack:ContextStatus->Void):Void{
		new RemotingGenericRequest<ContextStatus>('dicom/${sourceName}/context/${id}', callBack, new ContextStatus());
	}

	public static function getAllIds(sourceName:String, callBack:Array<String>->Void):Void{
		new RemotingGenericRequest<Array<String>>('dicom/${sourceName}/ids', callBack);
	}

	public static function contextData(sourceName:String, id:String, callBack:DicomContextData->Void):Void{
		new RemotingGenericRequest<DicomContextData>('dicom/${sourceName}/context/${id}/data', callBack, new DicomContextData());
	}

	public static function getSeriesInstances(sourceName:String, seriesUID:String, callBack:Array<String>->Void):Void{
		new RemotingGenericRequest<Array<String>>('dicom/${sourceName}/series/${seriesUID}/instances', callBack);
	}

	public static function gitVersion(callBack:String->Void):Void{
		new RemotingGenericRequest<String>('utils/build-version', callBack);
	}

	public static function volumeHistogram(sourceName:String, id:String, callBack:Histogram->Void):Void{
		new RemotingGenericRequest<Histogram>('dicom/${sourceName}/context/${id}/histogram', callBack, new Histogram());
	}

	public static function serverCheck(callBack:String->Void):Void{
		new RemotingGenericRequest<String>('utils/server-check', callBack);
	}

	public static function getDicomImageData(sourceName:String, id:String, callBack:DicomImageData->Void):Void{
		new RemotingGenericRequest<DicomImageData>('dicom/${sourceName}/data/${id}', callBack, new DicomImageData());
	}

	public static function ecgData(sourceName:String, id:String, callBack:Array<ECGData>->Void):Void{
		new RemotingGenericRequest<Array<ECGData>>('dicom/${sourceName}/context/${id}/ecg', callBack);
	}

	public static function colorLUTs(callBack:Array<ColorLUT>->Void):Void{
		new RemotingGenericRequest<Array<ColorLUT>>('dicom/colorLuts', callBack);
	}
}
